import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Errors, Form, Control } from 'react-redux-form';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import ArrowButton from '../../../../common/button-arrow';
import RequiredInput from '../../../../common/form/elements/required-input';
import RequiredSelect from '../../../../common/form/elements/required-select';

class AccountManagerForm extends Component {
  render() {
    const { formValid, model, onSubmit, voucherTypes } = this.props;

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid">
          <Form model={model} onSubmit={onSubmit}>
            <Row>
              <Col md={12}>
                <Errors className="errors" model={model} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  label="Account manager code"
                  placeholder="Account manager code"
                  model=".account_manager_code"
                  controlId="account-manager-code"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  label="Email"
                  placeholder="Email"
                  model=".email"
                  controlId="email"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <RequiredSelect 
                  model=".voucher_type_id"
                  values={voucherTypes || []}
                  label="Voucher"
                  controlId="voucher"
                  labelAttr="name"
                  valueAttr="id"
                  hasEmptyValue
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
              <FormGroup controlId="key_account_first_name">
                <ControlLabel>Key Account First Name</ControlLabel>
                <Control.text model=".key_account_first_name" component={FormControl} />
              </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
              <FormGroup controlId="key_account_last_name">
                <ControlLabel>Key Account Last Name</ControlLabel>
                <Control.text model=".key_account_last_name" component={FormControl} />
              </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
              <FormGroup controlId="key_account_email">
                <ControlLabel>Key Account Email</ControlLabel>
                <Control.text model=".key_account_email" component={FormControl} />
              </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={2} mdOffset={10}>
                <ArrowButton
                  className="pull-right"
                  arrow={false}
                  disabled={!formValid}
                >
                  Save
                </ArrowButton>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValid: state.deep.forms.admin_account_manager_save.$form.valid,
  voucherTypes: state.accountManagers.voucherTypes
});

export default connect(mapStateToProps)(AccountManagerForm);



// WEBPACK FOOTER //
// ./src/components/admin/ho-accounts/account-managers/form/account-manager-form.jsx